(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.category-banner-carousel').forEach((carousel) => {
    const track = carousel.querySelector('.category-banner-carousel__track');
    const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));
    const previous = carousel.querySelector('[data-carousel-previous]');
    const next = carousel.querySelector('[data-carousel-next]');

    if (!track || slides.length < 2) return;

    let currentIndex = 0;

    const updateDots = (index) => {
      currentIndex = index;
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
        if (dotIndex === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const goTo = (index) => {
      const safeIndex = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[safeIndex].offsetLeft, behavior: 'smooth' });
      updateDots(safeIndex);
    };

    previous?.addEventListener('click', () => goTo(currentIndex - 1));
    next?.addEventListener('click', () => goTo(currentIndex + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));

    track.addEventListener('scrollend', () => {
      const closestIndex = slides.reduce((closest, slide, index) => {
        const currentDistance = Math.abs(track.scrollLeft - slide.offsetLeft);
        const closestDistance = Math.abs(track.scrollLeft - slides[closest].offsetLeft);
        return currentDistance < closestDistance ? index : closest;
      }, 0);
      updateDots(closestIndex);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["her-him-bundle"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hhb').forEach((root) => {
    const tabs = Array.from(root.querySelectorAll('.hhb__tab'));

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;
        tabs.forEach((item) => {
          const active = item.dataset.tab === target;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        root.querySelectorAll('.hhb__panel').forEach((panel) => {
          const active = panel.dataset.panel === target;
          panel.classList.toggle('is-active', active);
          panel.toggleAttribute('hidden', !active);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-clickable-banner"] && !Shopify.designMode) return;
  try {
    
  const initializeHeroCarousels = (root = document) => {
    root.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
      if (carousel.dataset.carouselInitialized === 'true') return;
      carousel.dataset.carouselInitialized = 'true';

      const track = carousel.querySelector('[data-hcb-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-hcb-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-hcb-dot]'));
      const previous = carousel.querySelector('[data-hcb-previous]');
      const next = carousel.querySelector('[data-hcb-next]');

      if (!track || slides.length < 2) return;

      // Add a visual copy of banner 1 after the last banner so autoplay can
      // keep moving forward instead of scrolling backwards from 3 to 1.
      const firstSlideClone = slides[0].cloneNode(true);
      firstSlideClone.removeAttribute('data-hcb-slide');
      firstSlideClone.setAttribute('data-hcb-clone', 'true');
      firstSlideClone.setAttribute('aria-hidden', 'true');
      firstSlideClone.setAttribute('inert', '');
      track.appendChild(firstSlideClone);
      const scrollSlides = [...slides, firstSlideClone];

      let currentIndex = 0;
      let autoplayTimer;
      let scrollTimer;
      let wrapTimer;
      let isWrapping = false;
      const autoplayEnabled = carousel.dataset.autoplay === 'true';
      const autoplaySeconds = Math.max(3, Number(carousel.dataset.autoplaySeconds) || 5);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const updateState = (index) => {
        currentIndex = index;
        slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
        });
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const resetToFirstSlide = () => {
        window.clearTimeout(wrapTimer);
        track.scrollTo({ left: slides[0].offsetLeft, behavior: 'auto' });
        updateState(0);
        window.requestAnimationFrame(() => {
          isWrapping = false;
        });
      };

      const goTo = (index, behavior = 'smooth') => {
        if (index === slides.length) {
          isWrapping = true;
          track.scrollTo({ left: firstSlideClone.offsetLeft, behavior });

          if (behavior === 'smooth') {
            wrapTimer = window.setTimeout(resetToFirstSlide, 700);
          } else {
            resetToFirstSlide();
          }
          return;
        }

        const safeIndex = (index + slides.length) % slides.length;
        track.scrollTo({ left: slides[safeIndex].offsetLeft, behavior });
        updateState(safeIndex);
      };

      const stopAutoplay = () => {
        window.clearInterval(autoplayTimer);
      };

      const startAutoplay = () => {
        stopAutoplay();
        if (!autoplayEnabled || reduceMotion || document.hidden) return;
        autoplayTimer = window.setInterval(() => goTo(currentIndex + 1), autoplaySeconds * 1000);
      };

      previous?.addEventListener('click', () => {
        goTo(currentIndex - 1);
        startAutoplay();
      });
      next?.addEventListener('click', () => {
        goTo(currentIndex + 1);
        startAutoplay();
      });
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          goTo(index);
          startAutoplay();
        });
      });

      track.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => {
          if (isWrapping) return;

          const closestIndex = scrollSlides.reduce((closest, slide, index) => {
            const currentDistance = Math.abs(track.scrollLeft - slide.offsetLeft);
            const closestDistance = Math.abs(track.scrollLeft - scrollSlides[closest].offsetLeft);
            return currentDistance < closestDistance ? index : closest;
          }, 0);

          if (closestIndex === slides.length) {
            isWrapping = true;
            resetToFirstSlide();
            return;
          }

          updateState(closestIndex);
        }, 100);
      }, { passive: true });

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', startAutoplay);
      document.addEventListener('visibilitychange', startAutoplay);

      updateState(0);
      startAutoplay();
    });
  };

  initializeHeroCarousels();
  document.addEventListener('shopify:section:load', (event) => initializeHeroCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kino-account-hub"] && !Shopify.designMode) return;
  try {
    
  function initializeKinoOrderButtons(scope) {
    scope.querySelectorAll('[data-kino-more-orders]').forEach((button) => {
      if (button.dataset.kinoReady === 'true') return;
      button.dataset.kinoReady = 'true';

      button.addEventListener('click', () => {
        const orders = button.closest('.kino-account__card--orders');
        const expanded = button.getAttribute('aria-expanded') === 'true';
        const nextExpanded = !expanded;

        orders.querySelectorAll('.kino-account__order--extra').forEach((order) => {
          order.hidden = !nextExpanded;
        });

        button.setAttribute('aria-expanded', String(nextExpanded));
        button.querySelector('span').textContent = nextExpanded ? 'Show fewer' : 'View more orders';
      });
    });
  }

  initializeKinoOrderButtons(document);

  document.addEventListener('shopify:section:load', (event) => {
    initializeKinoOrderButtons(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-finder-ai"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.kfinder').forEach((root) => {
      const productNode = document.querySelector(`[data-products-${root.id.replace('KFinder-', '')}]`);
      if (!productNode) return;
      const products = JSON.parse(productNode.textContent);
      const panels = [...root.querySelectorAll('[data-step]')];
      const progress = root.querySelector('[data-progress]');
      const progressTrack = root.querySelector('.kfinder__progress');
      const back = root.querySelector('[data-back]');
      const history = ['start'];
      const state = { mode: null, age: null, gender: null, concern: null, aiConcern: null, photo: null };
      const progressMap = { start: 10, scan: 25, analyzing: 35, confirm: 45, gender: 60, age: 78, concern: 92, result: 100 };

      const requireLogin = root.dataset.requireLogin === 'true';
      const isLoggedIn = root.dataset.customerLoggedIn === 'true';
      const customerId = root.dataset.customerId || '';
      const eventsEndpoint = root.dataset.eventsEndpoint || '';
      const timeoutMs = (parseInt(root.dataset.scanTimeout, 10) || 45) * 1000;
      const dailyLimit = parseInt(root.dataset.dailyLimit, 10) || 5;

      const loginModal = root.querySelector('[data-login-modal]');
      const modalGuided = root.querySelector('[data-modal-guided]');
      let modalOpener = null;

      /* ---- failure reporting -------------------------------------------- */

      // Vercel's Hobby plan keeps under an hour of logs, so failures are
      // reported to Supabase for a durable record. Fire and forget: reporting
      // must never block or break the customer's scan.
      const reportFailure = (errorType, detail, httpStatus) => {
        if (!eventsEndpoint) return;
        try {
          fetch(eventsEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'error',
              customer_id: customerId,
              error_type: errorType,
              detail: String(detail || '').slice(0, 500),
              http_status: httpStatus || null,
              endpoint: root.dataset.aiEndpoint || '',
              page_url: location.href
            }),
            keepalive: true
          }).catch(() => {});
        } catch (error) {
          /* ignore */
        }
      };

      const closeLoginModal = () => {
        if (!loginModal || loginModal.hidden) return;
        loginModal.hidden = true;
        document.body.style.overflow = '';
        modalOpener?.focus();
      };
      const openLoginModal = (opener) => {
        if (!loginModal) return;
        modalOpener = opener || document.activeElement;
        loginModal.hidden = false;
        document.body.style.overflow = 'hidden';
        loginModal.querySelector('.kfinder__modal-close')?.focus();
      };
      loginModal?.querySelectorAll('[data-modal-close]').forEach((button) => button.addEventListener('click', closeLoginModal));
      loginModal?.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { closeLoginModal(); return; }
        if (event.key !== 'Tab') return;
        const focusable = [...loginModal.querySelectorAll('a[href], button:not([disabled])')];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });

      const scanQuota = root.querySelector('[data-scan-quota]');
      if (scanQuota) scanQuota.textContent = `You can run up to ${dailyLimit} AI Skin Scans per day.`;

      const show = (step, push = true) => {
        panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.step === step));
        root.classList.toggle('is-start', step === 'start');
        progress.style.width = `${progressMap[step]}%`;
        progressTrack.hidden = step === 'start';
        back.hidden = step === 'start';
        if (push && history[history.length - 1] !== step) history.push(step);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      const photoInput = root.querySelector('[data-photo]');
      const preview = root.querySelector('[data-photo-preview]');
      const consent = root.querySelector('[data-consent]');
      const scanContinue = root.querySelector('[data-scan-continue]');
      const scanMessage = root.querySelector('[data-scan-message]');
      const scanErrorActions = root.querySelector('[data-scan-error-actions]');
      const scanRetry = root.querySelector('[data-scan-retry]');

      const updateContinue = () => { scanContinue.disabled = !(state.photo && consent.checked); };

      /* ---- visible failure states --------------------------------------- */

      // A system failure: something on our side went wrong. Offer retry + guided.
      const setScanError = (message) => {
        scanMessage.textContent = message;
        scanMessage.classList.add('is-error');
        if (scanRetry) scanRetry.hidden = false;
        if (scanErrorActions) scanErrorActions.hidden = false;
      };
      // Daily limit reached. Expected behaviour, not a fault -- and retrying
      // today cannot succeed, so the retry button is hidden.
      const setScanLimit = (message) => {
        scanMessage.textContent = message;
        scanMessage.classList.add('is-error');
        if (scanRetry) scanRetry.hidden = true;
        if (scanErrorActions) scanErrorActions.hidden = false;
      };
      // A photo problem: the customer just needs a better shot. No error styling.
      const setScanNotice = (message) => {
        scanMessage.textContent = message;
        scanMessage.classList.remove('is-error');
        if (scanErrorActions) scanErrorActions.hidden = true;
      };
      const clearScanError = () => {
        scanMessage.textContent = '';
        scanMessage.classList.remove('is-error');
        if (scanRetry) scanRetry.hidden = false;
        if (scanErrorActions) scanErrorActions.hidden = true;
      };

      // Always re-enable the Analyze button when we send someone back to the
      // scan step, otherwise one failure leaves the button permanently greyed.
      const backToScan = () => { show('scan', false); updateContinue(); };

      root.querySelectorAll('[data-mode]').forEach((button) => button.addEventListener('click', () => {
        state.mode = button.dataset.mode;
        if (state.mode === 'scan') {
          if (requireLogin && !isLoggedIn) { openLoginModal(button); return; }
          clearScanError();
          show('scan');
        } else {
          show('gender');
        }
      }));

      modalGuided?.addEventListener('click', () => {
        closeLoginModal();
        state.mode = 'guided';
        show('gender');
      });

      photoInput?.addEventListener('change', () => {
        const file = photoInput.files?.[0];
        if (!file) return;
        state.photo = file;
        clearScanError();
        const reader = new FileReader();
        reader.onload = () => { preview.style.backgroundImage = `url(${reader.result})`; preview.classList.add('has-image'); };
        reader.readAsDataURL(file);
        updateContinue();
      });
      consent?.addEventListener('change', updateContinue);

      const compressPhoto = (file, maxDim = 1024, quality = 0.82) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const img = new Image();
          img.onload = () => {
            let { width, height } = img;
            if (width > height && width > maxDim) { height = Math.round((height * maxDim) / width); width = maxDim; }
            else if (height > maxDim) { width = Math.round((width * maxDim) / height); height = maxDim; }
            const canvas = document.createElement('canvas');
            canvas.width = width; canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            resolve(canvas.toDataURL('image/jpeg', quality));
          };
          img.onerror = reject;
          img.src = reader.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });

      const aiConcernMap = { fine_lines: 'fine-lines', visible_firmness: 'firmness', uneven_tone_dark_spots: 'dark-spots', dullness: 'dullness' };
      const confirmTitle = {
        'fine-lines': 'Visible fine lines detected',
        firmness: 'Visible loss of firmness detected',
        'dark-spots': 'Dark spots or uneven tone detected',
        dullness: 'Visible dullness detected'
      };
      const confirmCopy = {
        'fine-lines': 'Some fine lines appear visible in this photo.',
        firmness: 'Your skin appears to show some visible loss of firmness in this photo.',
        'dark-spots': 'Some dark spots or uneven-looking areas appear visible in this photo.',
        dullness: 'Your skin appears slightly dull or tired-looking in this photo.'
      };

      const analyzePhoto = async () => {
        const endpoint = root.dataset.aiEndpoint;
        state.aiConcern = null;

        if (!endpoint) {
          setScanError('The AI Skin Scan is not available right now. You can continue with the Guided Beauty Finder instead.');
          reportFailure('analysis_unavailable', 'ai_endpoint setting is empty');
          backToScan();
          return;
        }
        if (!state.photo) { backToScan(); return; }

        clearScanError();
        show('analyzing');

        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), timeoutMs);

        try {
          const image = await compressPhoto(state.photo);
          const res = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ image, customer_id: customerId }),
            signal: controller.signal
          });
          clearTimeout(timer);

          if (!res.ok) {
            const detail = await res.text().catch(() => '');
            setScanError(`We could not complete the analysis just now (error ${res.status}). Please try again in a moment, or continue with the Guided Beauty Finder.`);
            reportFailure('http_error', detail, res.status);
            backToScan();
            return;
          }

          let data;
          try {
            data = await res.json();
          } catch (error) {
            setScanError('We could not read the analysis result. Please try again, or continue with the Guided Beauty Finder.');
            reportFailure('bad_response', 'response body was not valid JSON', res.status);
            backToScan();
            return;
          }

          // The analysis API owns the daily limit (5 per customer, held in
          // Redis). It answers 200 with this error rather than a 429, and it
          // is normal behaviour -- so it is shown to the customer but never
          // reported as a failure or emailed to the team.
          if (data && data.error === 'rate_limit_exceeded') {
            setScanLimit(
              data.photo_quality?.retake_instruction ||
              `You have reached today's AI Skin Scan limit of ${dailyLimit}. Please try again tomorrow, or use the Guided Beauty Finder.`
            );
            backToScan();
            return;
          }

          if (data && data.error === 'analysis_unavailable') {
            setScanError('Our analysis service did not respond as expected. Please try again shortly, or continue with the Guided Beauty Finder.');
            reportFailure('analysis_unavailable', JSON.stringify(data).slice(0, 500), res.status);
            backToScan();
            return;
          }

          if (data && data.photo_quality && data.photo_quality.status === 'retake_required') {
            setScanNotice(data.photo_quality.retake_instruction || 'Please retake your photo in good lighting, facing the camera directly.');
            backToScan();
            return;
          }

          const detected = data && data.primary_visible_concern ? aiConcernMap[data.primary_visible_concern] : null;

          if (detected) {
            state.aiConcern = detected;
            root.querySelector('[data-confirm-title]').textContent = confirmTitle[detected];
            root.querySelector('[data-confirm-text]').textContent = confirmCopy[detected];
            show('confirm');
            return;
          }

          setScanNotice('We could not identify a clear primary concern from this photo. You can retake it, or answer a few quick questions instead.');
          backToScan();
        } catch (error) {
          clearTimeout(timer);
          if (error && error.name === 'AbortError') {
            setScanError('The analysis is taking longer than usual. Please try again, or continue with the Guided Beauty Finder.');
            reportFailure('timeout', `aborted after ${timeoutMs}ms`);
          } else {
            setScanError('We could not reach the analysis service. Please check your connection and try again, or continue with the Guided Beauty Finder.');
            reportFailure('network_error', String((error && error.message) || error));
          }
          backToScan();
        }
      };

      scanContinue?.addEventListener('click', () => { scanContinue.disabled = true; analyzePhoto(); });
      scanRetry?.addEventListener('click', () => { clearScanError(); analyzePhoto(); });
      root.querySelector('[data-scan-use-guided]')?.addEventListener('click', () => {
        clearScanError();
        state.mode = 'guided';
        show('gender');
      });

      root.querySelector('[data-confirm-yes]')?.addEventListener('click', () => {
        state.concern = state.aiConcern;
        show('gender');
      });
      root.querySelector('[data-confirm-no]')?.addEventListener('click', () => {
        state.concern = null;
        show('gender');
      });

      const configureConcernChoices = () => {
        const useMenChoices = state.gender === 'male' && !state.concern;
        root.querySelectorAll('[data-concern-group]').forEach((button) => {
          button.hidden = useMenChoices
            ? button.dataset.concernGroup !== 'male'
            : button.dataset.concernGroup !== 'skin';
        });
        root.querySelector('[data-concern-heading]').textContent = useMenChoices
          ? 'What support are you looking for?'
          : 'What would you most like to improve?';
        root.querySelector('[data-concern-copy]').textContent = useMenChoices
          ? 'Choose your main priority so we can recommend the most suitable men’s formula.'
          : 'Choose one priority so we can give you a clear first recommendation.';
      };

      root.querySelectorAll('[data-gender]').forEach((button) => button.addEventListener('click', () => {
        state.gender = button.dataset.gender;
        configureConcernChoices();
        if (state.gender === 'male' && !state.concern) {
          show('concern');
        } else {
          show('age');
        }
      }));

      const rules = {
        'fine-lines': {
          heading: 'Your collagen support match', intro: 'We matched your details with your priority of visible fine lines.',
          choose: () => state.gender === 'male'
            ? [['collagen-men-pro', 'Best match', 'Formulated for men with 5500mg marine collagen, NMN and Vitamin C—smooths skin, controls oil and helps with firmness.'], ['collagen-men', 'Simpler alternative', 'A lower-complexity daily marine collagen for men, for hydration and smoother-looking skin.']]
            : state.age === 'under25'
              ? [['collagen-diamond', 'Best match', 'A straightforward daily collagen option for maintaining hydrated, plump-looking skin.']]
              : state.age === '25to34'
                ? [['collagen-diamond-pro', 'Best match', 'The advanced collagen formula with NMN and trans-resveratrol is positioned for firming, radiance and anti-ageing support.'], ['collagen-diamond', 'Simpler alternative', 'A lower-complexity daily collagen option for hydration and plump-looking skin.']]
                : [['stemcell', 'Best match', 'Kinohimitsu’s targeted anti-ageing option for visible fine lines, firmness and elasticity.'], ['collagen-diamond-pro', 'Supporting option', 'Advanced collagen support with NMN and trans-resveratrol for firmness and radiance.']]
        },
        firmness: {
          heading: 'Your targeted anti-ageing match', intro: 'You told us firmness and elasticity are your main priorities.',
          choose: () => state.gender === 'male'
            ? [['collagen-men-pro', 'Best match', 'Formulated for men—5500mg marine collagen with NMN and Vitamin C for firmness and skin support.'], ['collagen-men', 'Supporting option', 'A lower-complexity daily marine collagen for men.']]
            : [['stemcell', 'Best match', 'The targeted anti-ageing formula for visible loss of firmness, elasticity and fine lines.'], ['collagen-diamond-pro', 'Supporting option', 'Advanced collagen support positioned for firming, uplifting and radiance.']]
        },
        'dark-spots': {
          heading: 'Your even-tone match', intro: 'You selected visible dark spots and uneven tone as your priority.',
          choose: () => state.gender === 'male'
            ? [['collagen-men-pro-prowhite', 'Best match — men’s bundle', 'Pairs Collagen Men Pro with ProWhite for combined skin support and brightening, formulated with men in mind.'], ['prowhite', 'Alternative', 'A brightening option positioned for pigmentation, dullness and dark eye circles.']]
            : [['snow-activ', 'Best match', 'Its factsheet positions it for stubborn hyperpigmentation, uneven tone and photo-ageing.'], ['prowhite', 'Alternative', 'A brightening option positioned for pigmentation, dullness and dark eye circles.']]
        },
        dullness: {
          heading: 'Your radiance match', intro: 'You selected dull or tired-looking skin as your priority.',
          choose: () => state.gender === 'male'
            ? [['collagen-men-pro-prowhite', 'Best match — men’s bundle', 'Pairs Collagen Men Pro with ProWhite for combined skin support and brightening, formulated with men in mind.'], ['prowhite', 'Alternative', 'A brightening option positioned for pigmentation, dullness and dark eye circles.']]
            : [['prowhite', 'Best match', 'Its factsheet positions it for brightening, pigmentation and dark eye circles, with Vitamin C and glutathione in the formula.'], ['snow-activ', 'Alternative', 'A broader head-to-toe option for uneven tone and photo-ageing.']]
        },
        sun: { heading: 'Your outdoor skin-support match', intro: 'You told us you are frequently outdoors or exposed to strong sunlight.', choose: () => [['uv-bright-pro', 'Best match', 'Its factsheet positions it for frequent UV exposure, outdoor lifestyles and uneven tone.'], ['snow-activ', 'Supporting option', 'A complementary option positioned for uneven tone and photo-ageing.']] },
        'mens-wellness': {
          heading: 'Your everyday men’s wellness match',
          intro: 'You selected broad daily support for energy, focus and men’s wellness.',
          choose: () => [['3-in-1-his', 'Best all-round match', 'A convenient daily men’s formula positioned for energy, focus, liver and prostate support.']]
        },
        'mens-energy': {
          heading: 'Your energy and stamina match',
          intro: 'You selected targeted support for energy, stamina and daily performance.',
          choose: () => [['maca-men-pro', 'Best targeted match', 'A men’s formula designed to support lasting energy, stamina, focus and vitality in a convenient daily sachet.'], ['3-in-1-his', 'All-round alternative', 'A broader everyday men’s wellness formula for energy, focus, liver and prostate support.']]
        },
        'mens-skin-pro': {
          heading: 'Your men’s skin-balance match',
          intro: 'You selected oil balance, hydration and refined-looking pores as your priorities.',
          choose: () => [['collagen-men-pro', 'Best targeted match', '5500mg marine collagen with Nicotinamide and Green Caviar Extract to support firmness, hydration, balanced oil and refined-looking pores.'], ['collagen-men', 'Simpler alternative', 'A straightforward daily collagen option for men’s skin firmness, hydration and smoother-looking skin.']]
        },
        'mens-skin-daily': {
          heading: 'Your daily men’s collagen match',
          intro: 'You selected a straightforward daily routine for firmer, smoother-looking skin.',
          choose: () => [['collagen-men', 'Best everyday match', 'A straightforward daily collagen option for men’s skin firmness, hydration and smoother-looking skin.'], ['collagen-men-pro', 'Advanced alternative', 'An advanced 5500mg marine collagen formula with added support for oil balance and refined-looking pores.']]
        }
      };

      const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
      const card = ([handle, kicker, reason], index) => {
        const product = products[handle] || { title: handle, url: '#', image: '', price: '' };
        const image = product.image ? `<img class="kfinder__result-image" src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : '<div class="kfinder__result-image"></div>';
        return `<article class="kfinder__result-card${index === 0 ? ' is-primary' : ''}">${image}<div><p class="kfinder__result-kicker">${escapeHtml(kicker)}</p><h3>${escapeHtml(product.title)}</h3><p class="kfinder__result-price">${escapeHtml(product.price)}</p><p class="kfinder__result-reason">${escapeHtml(reason)}</p><a class="kfinder__result-link" href="${escapeHtml(product.url)}">View product →</a></div></article>`;
      };

      const computeResult = () => {
        const rule = rules[state.concern];
        root.querySelector('[data-result-heading]').textContent = rule.heading;
        root.querySelector('[data-result-intro]').textContent = rule.intro;
        root.querySelector('[data-results]').innerHTML = rule.choose().map(card).join('');
        show('result');
      };

      root.querySelectorAll('[data-age]').forEach((button) => button.addEventListener('click', () => {
        state.age = button.dataset.age;
        if (state.concern) { computeResult(); } else { show('concern'); }
      }));

      root.querySelectorAll('[data-concern]').forEach((button) => button.addEventListener('click', () => {
        state.concern = button.dataset.concern;
        computeResult();
      }));

      back.addEventListener('click', () => { if (history.length > 1) { history.pop(); show(history[history.length - 1], false); } });
      root.querySelector('[data-restart]').addEventListener('click', () => {
        state.mode = null; state.age = null; state.gender = null; state.concern = null; state.aiConcern = null; state.photo = null;
        configureConcernChoices();
        history.splice(0, history.length, 'start');
        if (photoInput) photoInput.value = '';
        if (preview) { preview.style.backgroundImage = ''; preview.classList.remove('has-image'); }
        if (consent) consent.checked = false;
        clearScanError();
        updateContinue(); show('start', false);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proof-reassurance"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.desktop-concern-nav').forEach((navigation) => {
    const originalParent = navigation.parentElement;
    const desktopQuery = window.matchMedia('(min-width: 990px)');

    const syncPosition = () => {
      const launchSection = document.querySelector('[id$="__new_launch_carousel"]');

      if (desktopQuery.matches && launchSection && launchSection.parentElement === originalParent.parentElement) {
        launchSection.insertAdjacentElement('afterend', navigation);
        return;
      }

      if (!desktopQuery.matches && navigation.parentElement !== originalParent) {
        originalParent.appendChild(navigation);
      }
    };

    syncPosition();
    desktopQuery.addEventListener('change', syncPosition);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-goal"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.shop-goal__card[href^="#"]');
    if (!link) return;

    const target = document.querySelector(link.getAttribute('href'));
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });

    window.history.replaceState(null, '', link.getAttribute('href'));
  });

  } catch(e) { console.error(e); }
})();
})();
